'use client';

import { HStack, VStack } from '@terra/ui-styled-system';
import { MetaDefault } from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';
import { COMPOSITION_VISUAL_KINDS } from '../utils/compositionGraphModel';
import {
  COMPOSITION_HIDDEN_DOT,
  COMPOSITION_SHOWN_DOT,
  COMPOSITION_VERIFIED_BORDER,
  COMPOSITION_VISUAL_STYLE,
} from '../utils/compositionGraphVisual';

export function AiApplicationCompositionLegend() {
  const t = useTranslations('aiApplications.graph');
  const tTypes = useTranslations('aiApplications.componentTypes');
  const tVerification = useTranslations('aiApplications.assets.verification');
  const kindLabel: Record<(typeof COMPOSITION_VISUAL_KINDS)[number], string> = {
    AGENT: tTypes('agent'),
    ROUTER: t('kinds.router'),
    MIDDLEWARE: t('kinds.middleware'),
    MEMORY: tTypes('memory'),
    TOOL_FUNCTION: t('kinds.toolFunction'),
    TOOL_HOSTED: t('kinds.hostedTool'),
    TOOL: tTypes('tool'),
  };

  return (
    <HStack
      flexShrink={0}
      flexWrap="wrap"
      gap="8px"
      columnGap="18px"
      alignItems="center"
      px="16px"
      py="12px"
      borderTopWidth="1px"
      borderColor="border.neutral.subtle"
      bg="bg.default"
    >
      {COMPOSITION_VISUAL_KINDS.map((kind) => {
        const visual = COMPOSITION_VISUAL_STYLE[kind];
        const Icon = visual.icon;

        return (
          <HStack key={kind} gap="6px" alignItems="center">
            <HStack
              w="20px"
              h="20px"
              borderRadius="5px"
              alignItems="center"
              justifyContent="center"
              style={{
                background: visual.bg,
                color: visual.fg,
                boxShadow: `inset 0 0 0 1px ${visual.bd}`,
              }}
            >
              <Icon size={12} />
            </HStack>
            <MetaDefault whiteSpace="nowrap">{kindLabel[kind]}</MetaDefault>
          </HStack>
        );
      })}
      <VStack w="1px" h="16px" bg="border.neutral.subtle" />
      <HStack gap="6px" alignItems="center">
        <VStack
          w="6px"
          h="6px"
          borderRadius="full"
          style={{ background: COMPOSITION_SHOWN_DOT }}
        />
        <MetaDefault whiteSpace="nowrap">{t('shownInExchange')}</MetaDefault>
      </HStack>
      <HStack gap="6px" alignItems="center">
        <VStack
          w="6px"
          h="6px"
          borderRadius="full"
          style={{ background: COMPOSITION_HIDDEN_DOT }}
        />
        <MetaDefault whiteSpace="nowrap">{t('ranInBackground')}</MetaDefault>
      </HStack>
      <HStack gap="6px" alignItems="center">
        <VStack
          w="14px"
          h="10px"
          borderRadius="3px"
          borderWidth="1.5px"
          style={{ borderColor: COMPOSITION_VERIFIED_BORDER }}
        />
        <MetaDefault whiteSpace="nowrap">
          {tVerification('verified')}
        </MetaDefault>
      </HStack>
    </HStack>
  );
}
